import React from 'react';
import './Preloader.css';

function Preloader() {
  return (
    <i className="circle-preloader"></i>
  );
}

export default Preloader;

